/**
 * Menu Lateral do Dashboard - Inspirado no Meu Dinheiro
 * Seletor de mês e configurações de visualização
 */

import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Typography,
  Divider,
  Tooltip,
  Paper,
} from '@mui/material';
import {
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  Today as TodayIcon,
  SettingsApplications as SettingsIcon,
} from '@mui/icons-material';
import { useTheme } from '../context/ThemeContext';

const DashboardSidebar = ({ mesAtual, anoAtual, onMesChange, onConfigOpen }) => {
  const { isDarkMode } = useTheme();
  const [mes, setMes] = useState(mesAtual);
  const [ano, setAno] = useState(anoAtual);

  const mesesAbrev = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
  
  const dataAtual = new Date();
  const mesAtualReal = dataAtual.getMonth() + 1;
  const anoAtualReal = dataAtual.getFullYear();

  const isDataAtual = mes === mesAtualReal && ano === anoAtualReal;

  /**
   * Navega para o mês anterior
   */
  const navegarAnterior = () => {
    let novoMes = mes - 1;
    let novoAno = ano;

    if (novoMes < 1) {
      novoMes = 12;
      novoAno -= 1;
    }

    setMes(novoMes);
    setAno(novoAno);
    onMesChange(novoMes, novoAno);
  };

  /**
   * Navega para o próximo mês
   */
  const navegarProximo = () => {
    let novoMes = mes + 1;
    let novoAno = ano;

    if (novoMes > 12) {
      novoMes = 1;
      novoAno += 1;
    }

    setMes(novoMes);
    setAno(novoAno);
    onMesChange(novoMes, novoAno);
  };

  /**
   * Volta para o mês atual
   */
  const voltarHoje = () => {
    setMes(mesAtualReal);
    setAno(anoAtualReal);
    onMesChange(mesAtualReal, anoAtualReal);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        position: 'fixed',
        left: 0,
        top: 50,
        height: 'calc(100vh - 50px)',
        width: 80,
        padding: '24px 8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        backgroundColor: 'background.default',
        border: 'none',
        zIndex: 999,
        '@media (max-width: 960px)': {
          display: 'none',
        },
      }}
    >
      {/* Botão Anterior */}
      <Tooltip title="Mês anterior" placement="right">
        <IconButton
          onClick={navegarAnterior}
          size="small"
          sx={{
            color: 'text.secondary',
            '&:hover': {
              backgroundColor: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
            },
          }}
        >
          <ExpandLessIcon />
        </IconButton>
      </Tooltip>

      {/* Display do Mês/Ano */}
      <Box
        sx={{
          textAlign: 'center',
          py: 1,
          cursor: 'default',
          userSelect: 'none',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            fontSize: '0.9em',
            color: 'text.primary',
            textTransform: 'lowercase',
          }}
        >
          {mesesAbrev[mes - 1]}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            fontSize: '0.8em',
            color: 'text.secondary',
          }}
        >
          {ano.toString().slice(-2)}
        </Typography>
      </Box>

      {/* Botão Próximo */}
      <Tooltip title="Próximo mês" placement="right">
        <IconButton
          onClick={navegarProximo}
          size="small"
          sx={{
            color: 'text.secondary',
            '&:hover': {
              backgroundColor: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
            },
          }}
        >
          <ExpandMoreIcon />
        </IconButton>
      </Tooltip>

      {/* Botão Hoje */}
      <Tooltip title="Ir para data atual" placement="right">
        <span>
          <IconButton
            onClick={voltarHoje}
            disabled={isDataAtual}
            size="small"
            sx={{
              color: isDataAtual ? 'text.disabled' : 'text.secondary',
              '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
              },
            }}
          >
            <TodayIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      <Divider sx={{ width: '100%', my: 1 }} />

      {/* Botão Configurar */}
      <Tooltip title="Personalizar dashboard" placement="right">
        <IconButton
          onClick={onConfigOpen}
          size="small"
          sx={{
            color: 'text.secondary',
            '&:hover': {
              backgroundColor: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
            },
          }}
        >
          <SettingsIcon />
        </IconButton>
      </Tooltip>
    </Paper>
  );
};

export default DashboardSidebar;
